import React, { useState, useEffect } from "react";
import { useRouter } from "./../util/router";
import ExtractContent from "./../components/extract/ExtractContent";
import NotFoundPage from "../components/general/NotFound";
import { useUser } from "../util/user";

function ExtractPage() {
  const [hasAccess, setHasAccess] = useState(false);
  const router = useRouter();
  const userObj = useUser();

  useEffect(() => {
    if (userObj != null) {
      if (userObj.roles != null && userObj.roles.includes("extract:_view"))
        setHasAccess(true);

    } else
      router.push("/solar/logout");
  }, [userObj]);
  return hasAccess ? <ExtractContent /> : <NotFoundPage />;
}

export default ExtractPage;
